import {Observable} from 'rxjs';
import {
    AppsICanManage,
    AppsICanManage_appsICanManage,
    AppsICanManage_appsICanManage_nodes,
    AppsICanManageVariables,
} from './gql/AppsICanManage';
import {AppsPermissionsScope} from 'src/globalTypes';
import {ApiService} from 'app/shared/modules/api/services/api.service';
import {pluck} from 'rxjs/operators';
import {gql} from 'apollo-angular';
import {appQuery} from 'app/features/apps/services/manage-app.service';
import {app} from 'app/features/apps/services/gql/app';

export const appsICanManageQuery = gql`
    query AppsICanManage($scope: AppsPermissionsScope, $userId: ID, $searchQuery: String) {
        appsICanManage(scope: $scope, userId: $userId, searchQuery: $searchQuery) {
            nodes {
                id
                label
                ownerId
                platform
                searchString
                permissions {
                    canViewNewMediationSettings
                }
            }
            appOwners {
                id
                email
            }
            isCompleteList
            totalCount
        }
    }
`;

export class AppICanFetcher {
    constructor(
        private api: ApiService,
        private scope: AppsPermissionsScope = AppsPermissionsScope.MANAGE_APPS
    ) {}

    search(userId: string, searchQuery: string = '') {
        return this.fetch(userId, this.scope, searchQuery);
    }

    loadAppsICanManage(userId: string): Promise<AppsICanManage_appsICanManage> {
        return this.fetch(userId, this.scope).toPromise();
    }

    loadUserApps(userId: string): Promise<AppsICanManage_appsICanManage_nodes[]> {
        return this.fetch(userId, this.scope).pipe(pluck('nodes')).toPromise();
    }

    fetch(
        userId: string,
        scope: AppsPermissionsScope = AppsPermissionsScope.MANAGE_APPS,
        searchQuery: string = ''
    ): Observable<AppsICanManage_appsICanManage> {
        return this.api
            .query<AppsICanManage, AppsICanManageVariables>({
                fetchPolicy: 'network-only',
                query: appsICanManageQuery,
                variables: {
                    searchQuery,
                    scope,
                    userId,
                },
            })
            .pipe(pluck('appsICanManage'));
    }

    fetchApp(appId: string) {
        return this.api
            .query<app>({
                query: appQuery,
                variables: {
                    id: appId,
                },
                fetchPolicy: 'network-only',
            })
            .pipe(pluck('app'))
            .toPromise();
    }
}
